import { PRESUPUESTADOR_SET_BRANCH_OFFICE_LIST } from './constants'

export function setBranchOfficeList(branchOfficeList) {
  return (dispatch)=>{
    dispatch ({
      type: PRESUPUESTADOR_SET_BRANCH_OFFICE_LIST,
      data: { branchOfficeList }
    })
  }
}  

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SET_BRANCH_OFFICE_LIST:
      return {
        ...state,
        branchOfficeList: action.data?.branchOfficeList
      }

    default:
      return state
  }
}